import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { appLayoutRoute } from '@/app/routes/roots';
import { validateListSearch } from '@/shared/lib/listSearch';

export const usersRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/users',
  component: lazyRouteComponent(() => import('./pages/UsersPage'), 'UsersPage'),
  validateSearch: validateListSearch,
});

export const usersRoutes = [usersRoute];
